// extracted by mini-css-extract-plugin
export default {"message":"messagePopover-module__message___scbSD","show":"messagePopover-module__show___FjKeA","abovePlayer":"messagePopover-module__abovePlayer___l60QG"};